import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export default function IconBigdata({
    width = 20,
    height = 20,
    className,
    ...rest
}) {
    return (
        <svg
            fillRule="evenodd"
            viewBox="0 0 20 20"
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...rest}
        >
            <title>Icon bigdata</title>
            <path
                d="M10.5321 0.128046C10.3664 0.0400143 10.1745 0 9.99128 0C9.8081 0 9.62492 0.0400143 9.4679 0.144051L2.53319 3.81736C2.18428 3.99342 1.99237 4.32955 2.00109 4.66567V4.67367V15.2935V15.3255C1.98365 15.6696 2.17555 16.0137 2.52447 16.1978L9.45918 19.8711C9.62491 19.9591 9.81682 19.9991 10 19.9991C10.1832 20.0071 10.3664 19.9591 10.5408 19.8711L17.4755 16.1738C17.8244 15.9897 18.0164 15.6456 17.9989 15.3015V15.2694V4.65766V4.64966C17.9989 4.31354 17.807 3.98542 17.4668 3.80136L10.5321 0.128046ZM10.5408 14.4612L15.888 11.6281V14.7973L10 17.9184L4.11204 14.7973V11.6281L9.45919 14.4612C9.62492 14.5492 9.81683 14.5892 10 14.5892C10.1832 14.5972 10.3664 14.5492 10.5408 14.4612ZM15.888 6.34627L10.5408 9.17928C10.3664 9.26731 10.1832 9.31533 10 9.30732C9.81683 9.30732 9.62492 9.26731 9.45919 9.17928L4.11204 6.34627V9.38735L10 12.5085L15.888 9.38735V6.34627ZM10 7.22657L5.14134 4.65765C5.14134 4.65765 9.99128 2.08874 10 2.08073L14.8587 4.65765L10 7.22657Z"
                className={css.colored}
            />
        </svg>
    );
}
